export default function () {
	const slots = useSlots();
	const shouldSlotShow = computed(() => {
		return Object.keys(slots).length !== 0 ? true : false;
	});

	return shouldSlotShow;
}
